import { PlanFlat } from '../../domain/plan/PlanFlat';
import { TableColumn, parseDefaultTableColumns } from '../shared/tableColumns';

export const projectPlansTableColumnKeys = [
  `label`,
  `status`,
  `progress`,
  `total_drivers`,
  `total_stops`,
  `execution_date`,
] as const;

export type ProjectPlansTableColumnKeys = (typeof projectPlansTableColumnKeys)[number];

export type ProjectPlansTableColumn = TableColumn<ProjectPlansTableColumnKeys, PlanFlat>;

export const PROJECT_PLANS_DEFAULT_TABLE_COLUMNS: Array<ProjectPlansTableColumn> = [
  {
    identifier: `label`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `status`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `progress`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `total_drivers`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `total_stops`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
  {
    identifier: `execution_date`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: false,
  },
];

export const getProjectPlansTableColumns = (): Array<ProjectPlansTableColumn> => {
  const storedTableColumns = localStorage.getItem(`PROJECT_PLANS_TABLE_COLUMNS`);
  if (!storedTableColumns) return PROJECT_PLANS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<ProjectPlansTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: PROJECT_PLANS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setProjectPlansTableColumns = (tableColumns: Array<ProjectPlansTableColumn>) => {
  localStorage.setItem(`PROJECT_PLANS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
